import Vue from 'vue'
import App from './App.vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VeeValidate, { Validator } from 'vee-validate'
import {initValidator} from './validator'
import messages from './assets/js/zh_CN'
import './config/constants'
import { router } from './router';
import * as filters from './filters'
import './assets/css/main.css'


// Validator.updateDictionary({
//   zh_CN: {
//     messages
//   }
// })

// validate
Vue.use(VeeValidate, {
  locale: 'zh_CN'
})

initValidator(Validator)


// filter
Vue.filter('date', filters.dateFilter)
Vue.filter('date2', filters.dateFilter2)
Vue.filter('date3', filters.dateFilter3)
Vue.filter('star', filters.getStarFormat)
Vue.filter('thousands', filters.getThousandsFormat)


Vue.config.productionTip = true
Vue.use(VueAxios, axios)

// 4、登录中间验证，页面需要登录而没有登录的情况直接跳转登录 (暂时关闭验证)
router.beforeEach((to, from, next) => {
  if (to.meta.auth) {
    if (window.localStorage.user) {
      next()
    } else {
      let redirect = encodeURIComponent(to.path)
      next('/login?redirect=' + redirect)
    }
  } else {
    next()
  }
})

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
